import DischargeChecklistList from './DischargeChecklistList';

// Configuration > Discharge Checklist, for the acting client's own lists.
export default function DischargeChecklistPage() {
  return <DischargeChecklistList />;
}
